const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Runs an action up to `attempts` times until `isGood` accepts the result.
 * Returns the first good result, or the last result after exhausting attempts.
 */
export async function withRetry<T>(
  action: () => Promise<T>,
  isGood: (result: T) => boolean,
  attempts = 3,
  delayMs = 400,
): Promise<T> {
  let result = await action();
  for (let attempt = 1; attempt < attempts && !isGood(result); attempt += 1) {
    await wait(delayMs * attempt);
    result = await action();
  }
  return result;
}
